function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "Unauthorized Access"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "Sorry, you do not have access to this page or resource."
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "Go to Home"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React from "react";
import { t } from "ttag";
import { Button } from "antd";
import sessionsImage from "../../assets/sessions.svg";
import useTranslation from "../../hooks/useTranslation";
import Layout from "./Layout";
var HTTP403 = function(param) {
    var _param_scoped = param.scoped, scoped = _param_scoped === void 0 ? false : _param_scoped, _param_ctaText = param.ctaText, ctaText = _param_ctaText === void 0 ? null : _param_ctaText, _param_ctaHref = param.ctaHref, ctaHref = _param_ctaHref === void 0 ? "/" : _param_ctaHref, _param_title = param.title, title = _param_title === void 0 ? null : _param_title, _param_body = param.body, body = _param_body === void 0 ? null : _param_body, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? null : _param_onClick;
    useTranslation();
    return /*#__PURE__*/ React.createElement(Layout, {
        scoped: scoped,
        title: title !== null && title !== void 0 ? title : t(_templateObject()),
        body: body !== null && body !== void 0 ? body : t(_templateObject1()),
        image: sessionsImage,
        support: false
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        onClick: onClick || function() {
            return window.location.replace(ctaHref);
        }
    }, ctaText !== null && ctaText !== void 0 ? ctaText : t(_templateObject2())));
};
export default HTTP403;
